import {
  TagDetailsResponseSchema,
  TagResponseSchema,
  TagTypeSchema,
} from '../../tags';
import {TagName} from '../../validation';
import {ApiDefinition, ExtractRequestData} from '../definitions';
import {z} from 'zod';
import {ObjectIdSchema} from '../../zod';
import {AccountFilterSchema} from '../../filter/accountFilter';

export const GetTags = {
  path: 'tags',
  method: 'get',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({
    type: TagTypeSchema.optional(),
  }),
  responseDataSchema: TagResponseSchema.array(),
} satisfies ApiDefinition;

export const GetTagDetails = {
  path: 'tags/getTagDetails',
  method: 'get',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({
    tagId: ObjectIdSchema,
  }),
  responseDataSchema: TagDetailsResponseSchema,
} satisfies ApiDefinition;

const TagNameErrorMessage = `List names should be between ${TagName.minLength} and ${TagName.maxLength} characters, and contain only letters and numbers.`;
const TagNameSchema = z
  .string()
  .regex(TagName.pattern, TagNameErrorMessage)
  .min(TagName.minLength, TagNameErrorMessage)
  .max(TagName.maxLength, TagNameErrorMessage);

const SaveTagBaseSchema = z.object({
  id: ObjectIdSchema.optional(),
  name: TagNameSchema,
});

export const SaveTag = {
  path: 'tags/saveTag',
  method: 'post',
  options: {
    access: 'all',
  },
  requestDataSchema: z.discriminatedUnion('type', [
    SaveTagBaseSchema.extend({type: z.literal('static')}),
    SaveTagBaseSchema.extend({
      type: z.literal('dynamic'),
      filter: AccountFilterSchema,
    }),
  ]),
  responseDataSchema: TagResponseSchema,
} satisfies ApiDefinition;
export type SaveTagRequest = ExtractRequestData<typeof SaveTag>;

export const DeleteTag = {
  path: 'tags/deleteTag',
  method: 'post',
  options: {
    access: 'all',
  },
  requestDataSchema: z.object({
    tagId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
